import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useEffect, useState } from 'react';
import uuid from 'uuid/v4';
import { attempt } from 'lodash-es';
import useModifiedProps from '../UseModifiedProps';
import useAxis from '../UseAxis';
export default function usePlotBandLineLifecycle(props, plotType) {
  var _props$id = props.id,
      id = _props$id === void 0 ? uuid : _props$id,
      axisId = props.axisId,
      children = props.children,
      rest = _objectWithoutProperties(props, ["id", "axisId", "children"]);

  var axis = useAxis(axisId);
  var idRef = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      plotbandline = _useState2[0],
      setPlotbandline = _useState2[1];

  var modifiedProps = useModifiedProps(rest);
  useEffect(function () {
    if (!axis) return;

    if (!plotbandline || modifiedProps !== false) {
      if (!plotbandline) {
        idRef.current = typeof id === 'function' ? id() : id;
      }

      var myId = idRef.current;

      var opts = _objectSpread({
        id: myId
      }, rest);

      if (plotbandline) axis.removePlotBandOrLine(idRef.current);
      axis.addPlotBandOrLine(opts, plotType);
      setPlotbandline({
        id: myId,

        get object() {
          /* when parent axis is updated, the plotlines and plotbands are recreated
             therefore the object can't be cached here
          */
          if (axis && axis.object && axis.object.plotLinesAndBands) {
            return axis.object.plotLinesAndBands.find(function (plb) {
              return plb.id === myId;
            });
          }

          return null;
        }

      });
    }
  });
  useEffect(function () {
    return function () {
      attempt(axis.removePlotBandOrLine, idRef.current);
    };
  }, []);
  return plotbandline;
}